<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="입력" icon="pi pi-pencil" class="p-button-success mr-2" @click="btnAct('NEW')" />
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />        
            <Button label="저장" icon="pi pi-save" class="p-button-success mr-2" @click="btnAct('SAVE')" :disabled="(!selectedItems || !selectedItems.length) && !isExcelSave" />
            <Button label="삭제" icon="pi pi-trash" class="p-button-danger mr-2" @click="btnAct('DELETE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
            <FileUpload mode="basic" accept=".xlsx" :maxFileSize="10000000" 
                    @select="selectExcel" :auto="true" chooseLabel="엑셀업로드" :disabled="!searchParams.corpId || isExcelSave"/>
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                     <div class="p-field p-float-label m-2">
                        <Dropdown id="ctrPublicId" v-model="searchParams.ctrPublicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 10rem"
                                @change="changePublicId" :disabled="disabledCtrPublicId" scrollHeight="20em" :editable="true"/>
                        <label for="ctrPublicId">관할행정</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="custCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 10rem"
                                    @change="changeCustSeq" :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="areaTag" v-model="searchParams.areaTag" :options ="cboAreaTags" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 8rem" scrollHeight="20em"/>
                        <label for="areaTag">영역분류</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="runTag" v-model="searchParams.runTag" :options ="cboRunTags" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 12rem" scrollHeight="20em" :editable="true"/>
                        <label for="runTag">운행분류</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="useYn" v-model="searchParams.useYn" :options ="yns" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 8rem"/>
                        <label for="useYn">사용여부</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="carNo" v-model="searchParams.carNo" :options ="cboCarNos" optionLabel="codeNm" optionValue="codeNm" :showClear="true" style="width: 10rem" scrollHeight="20em" :editable="true"/>
                        <label for="carNo">차량번호</label>
                    </div>
                     <div class="p-field p-float-label m-2">
                        <Dropdown id="carTag" v-model="searchParams.carTag" :options ="carTag" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 8rem" />
                        <label for="carTag">차량종류</label>
                    </div>
                     <div class="p-field p-float-label m-2">
                        <Dropdown id="useOilTag" v-model="searchParams.useOilTag" :options ="cboOilTags" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 8rem" scrollHeight="20em" :editable="true"/>
                        <label for="useOilTag">사용연료</label>
                    </div>
                     <div class="p-field p-float-label m-2">
                        <InputText id="carModel" type="text" v-model="searchParams.carModel" style="width: 10rem"/>
                        <label for="carModel">모델명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="carMaker" type="text" v-model="searchParams.carMaker" style="width: 10rem"/>
                        <label for="carMaker">제작사명</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.strYmd" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>기준일자</label>
                    </div>
                </div> 
            </template>
            <template #end>
            </template>
        </Toolbar>

        <DataTable id="dt" ref="dt" :value="dataList" showGridlines :rowClass="excellrowcheckclass" v-if="!isExcelUpload" 
                    :scrollable="true" scrollHeight="79vh" :loading="loading" scrollDirection="both" rowIndexVar="rowIndex"
                    v-model:selection="selectedItems"
                    :paginator="true" :rows="15" :rowsPerPageOptions="[15, 20, 30]"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    responsiveLayout="scroll"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    editMode="cell" @cell-edit-complete="onCellEditComplete" class="editable-cells-table p-datatable-sm"
                    :resizableColumns="true" columnResizeMode="expand">
                
                <Column field="rowNo" header="No" style="min-width:3em; max-width:3em; z-index: 9" frozen exportFooter=" ">
                    <template #body="{data, field}">
                        <span name="rowNo" v-if="data[field] == '수정'" style="color: blue;">{{data[field]}}</span>
                        <span name="rowNo" v-else-if="data[field] == '신규'" style="color: red;">{{data[field]}}</span>
                        <span name="rowNo" v-else>{{data[field]}}</span> 
                    </template>
                </Column>
                <Column selectionMode="multiple" style="min-width:3em; max-width:3em; z-index: 9" :exportable="false" frozen exportFooter=" "></Column>
                <Column field="publicId" header="*소재지" style="min-width:8em; max-width:8em;" headerClass="required-field"  exportFooter=" ">
                    <template #body="{data}">
                        {{(publicCodes.find(e=>e.code == data.publicId)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="publicCodes" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="ctrPublicId" header="*관할행정구역" style="min-width:8em; max-width:8em;" headerClass="required-field"  exportFooter=" ">
                    <template #body="{data}">
                        {{(publicCodes.find(e=>e.code == data.ctrPublicId)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="publicCodes" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="corpId" header="업체ID" style="min-width:8em; max-width:8em;"  exportFooter=" "></Column>
                <Column field="corpNm" header="*업체명" :sortable="true" style="min-width:10em; max-width:10em;" headerClass="required-field"  exportFooter=" ">
                    <!-- <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="custCodes" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template> -->
                </Column>
                <Column field="carId" header="차량ID" :sortable="true" style="min-width:6em; max-width:6em; "  exportFooter=" "/>
                <Column field="carNo" header="*차량번호" :sortable="true" style="min-width:10em; max-width:10em;" headerClass="required-field"  exportFooter=" ">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:8em" autofocus />
                    </template>
                </Column>
                <Column field="areaTag" header="*영역분류" style="min-width:8em; max-width:8em" headerClass="required-field" exportFooter=" ">
                    <template #body="{data}">
                        {{(cboAreaTags.find(e=>e.code == data.areaTag)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="cboAreaTags" optionLabel="codeNm" optionValue="code" :editable="true" />
                    </template>
                </Column>
                <Column field="runTag" header="*운행분류" :sortable="true" style="min-width:8em; max-width:8em" headerClass="required-field" exportFooter=" ">
                    <template #body="{data}">
                        {{(cboRunTags.find(e=>e.code == data.runTag)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="cboRunTags" optionLabel="codeNm" optionValue="code" :editable="true" />
                    </template>
                </Column>
                <Column field="orgYy" header="*최초등록일자" :sortable="true" style="min-width:9em; max-width:9em" headerClass="required-field" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <Calendar v-model="data[field]" :maxDate="maxDateValue(data)" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar :showIcon="true" style="width: 8rem"/>
                    </template>
                </Column>
                <Column field="getYmd" header="*취득일자" :sortable="true" style="min-width:8em; max-width:8em" headerClass="required-field" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <Calendar v-model="data[field]" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar :showIcon="true" style="width: 8rem"/>
                    </template>
                </Column>
                <Column field="strYmd" header="개시일자" style="min-width:9em; max-width:9em" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <Calendar v-model="data[field]" :monthNavigator="true" :yearNavigator="true" showButtonBar :showIcon="true" style="width: 8rem"/>
                    </template>
                </Column>
                <Column field="endYmd" header="폐기일자" style="min-width:9em; max-width:9em" exportFooter=" ">
                    <template #body="{ data, field }">
                        {{ convertDateString(data[field]) }}
                    </template>
                    <template #editor="{ data, field }">
                        <Calendar v-model="data[field]" :minDate="endYmdDateValue(data)" :monthNavigator="true" :yearNavigator="true" showButtonBar :showIcon="true" style="width: 8rem"/>
                    </template>
                </Column>
                <Column field="getAmt" header="취득금액" style="min-width:10em; max-width:10em" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="10000000000" :useGrouping="false" inputStyle="width:8em"/>
                </template>
                </Column>
                <Column field="govAmt" header="국가보조금" style="min-width:10em; max-width:10em" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" :minFractionDigits="0" :maxFractionDigits="0" :min="0" :max="10000000000" :useGrouping="false" inputStyle="width:8em"/>
                </template>
                </Column>
                <Column field="useOilTag" header="*사용연료" :sortable="true" style="min-width:8em; max-width:8em" headerClass="required-field" exportFooter=" ">
                    <template #body="{data}">
                        {{(cboOilTags.find(e=>e.code == data.useOilTag)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="cboOilTags" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <Column field="carModel" header="모델명" style="min-width:15em; max-width:15em" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:13em"/>
                    </template>
                </Column>
                <Column field="carMaker" header="제작사" style="min-width:10em; max-width:10em" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:8em"/>
                    </template>
                </Column>
                <Column field="carTag" header="차량종류" style="min-width:8em; max-width:8em" exportFooter=" ">
                    <template #body="{data}">
                        {{(carTag.find(e=>e.code == data.carTag)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                        <Dropdown v-model="data[field]" :options="carTag" optionLabel="codeNm" optionValue="code" :editable="true"/>
                    </template>
                </Column>
                <!-- <Column field="remarks" header="비고" :sortable="true" style="min-width:200px; max-width:200px">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:10em"/>
                    </template>
                </Column> -->
                <Column field="useYn" header="사용여부" style="min-width:6em; max-width:6em" exportFooter=" ">
                    <template #body="{data}">
                        {{(yns.find(e=>e.code == data.useYn)||{codeNm:""})['codeNm']}}
                    </template>
                    <template #editor="{ data, field }">
                            <Dropdown v-model="data[field]" :options="yns" optionLabel="codeNm" optionValue="code" />
                    </template>
                </Column>
                <Column field="remarks" header="비고" style="min-width:30em; max-width:30em" exportFooter=" ">
                    <template #editor="{ data, field }">
                        <InputText v-model="data[field]" style="width:25em"/>
                    </template>
                </Column>
                <Column field="useYnCnt" header="사용중체크" style="min-width:6em; max-width:6em" hidden exportFooter=" "/>
        </DataTable>

        <!-- 엑셀데이터 목록 -->
        <DataTable :value="excelDataList" showGridlines scrollable scrollHeight="79vh" :rowClass="rowClass"
            :paginator="true" :rows="15" :rowsPerPageOptions="[15, 20, 30]"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            v-if="isExcelUpload" class="p-datatable-sm" :loading="loading" scrollDirection="both">
            <Column field="rowNo" header="No" style="min-width:3em; max-width:3em" frozen/>
            <Column field="publicId" header="*소재지" style="min-width:8em; max-width:8em"
                headerClass="required-field" frozen/>
            <Column field="ctrPublicNm" header="*관할행정" style="min-width:120px; max-width:120px" 
                headerClass="required-field" frozen/>
            <Column field="corpNm" header="*업체명" style="min-width:10em; max-width:10em"
                headerClass="required-field" frozen/>
            <Column field="carNo" header="*차량번호" style="min-width:8em; max-width:8em"
                headerClass="required-field"/>
            <Column field="areaTagNm" header="*영역분류" style="min-width:7em; max-width:7em"
                headerClass="required-field"/>
            <Column field="runTagNm" header="*운행분류" style="min-width:7em; max-width:7em"
                headerClass="required-field"/>
            <Column field="orgYy" header="*최초등록일자" style="min-width:9em; max-width:9em"
                headerClass="required-field"/>
            <Column field="getYmd" header="*취득일자" style="min-width:120px; max-width:120px"
                headerClass="required-field"/>
            <Column field="strYmd" header="개시일자" style="min-width:120px; max-width:120px">
                <template #body="{ data, field }">
                    {{ convertDateString(data[field]) }}
                </template>
            </Column>
            <Column field="endYmd" header="폐기일자" style="min-width:120px; max-width:120px">
                <template #body="{ data, field }">
                    {{ convertDateString(data[field]) }}
                </template>
            </Column>
            <Column field="getAmt" header="취득금액" :sortable="true" style="min-width:150px; max-width:150px">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
            </Column>
            <Column field="govAmt" header="국가보조금" :sortable="true" style="min-width:150px; max-width:150px">
                <template #body="{ data, field }">
                    <span style="display: inline-block;width: 95%; text-align: right;">{{ formatToPrice(data[field]) }}</span>
                </template>
            </Column>
            <Column field="useOilTagNm" header="*사용연료" :sortable="true" style="min-width:8em; max-width:8em"
                headerClass="required-field"/>
            <Column field="carModel" header="모델명" :sortable="true" style="min-width:15em; max-width:15em"/>
            <Column field="carMaker" header="제작사" :sortable="true" style="min-width:8em; max-width:8em"/>
            <Column field="carTagNm" header="차량종류" :sortable="true" style="min-width:8em; max-width:8em"/>
            <Column field="remarks" header="비고" :sortable="true" style="min-width:15em; max-width:15em"/>
            <Column field="errorMsg" header="에러메세지" style="width:30rem;" v-model:hidden="errorMsgvisible"/>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import MA301030Service from '@/service/ma/MA301030Service';
import JsUtils from '@/utilities/JsUtils';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from "primevue/useconfirm";
import MA301030ExcelTempService from '@/service/ma/MA301030ExcelTempService';
import XLSX from 'xlsx';

export default {
    setup() { 
        onMounted( async () => {
            searchParams.compSeq = 1;
            errorMsgvisible.value = true;

            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.fromDate = JsUtils.getDateString(fromDate);            
            searchParams.toDate = JsUtils.getDateString(new Date());          // 현재 일자

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
			codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> useOilTagCodes.value = data);  // 사용자권한 코드
            codeService.getCodeList({ compSeq:1, upCode:'_area_tag'}).then(data=> cboAreaTags.value = data);  // 영역분류 코드
            codeService.getCodeList({ compSeq:1, upCode:'_run_tag'}).then(data=> cboRunTags.value = data);  // 운행분류 코드
            codeService.getCodeList({ compSeq:1, upCode:'_useoil_tag'}).then(data=> cboOilTags.value = data);  // 사용연료

            cboCarNos.value = [];
            
            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                searchParams.userGbCd = user.userGbCd; // 사용자구분코드

                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                        //alert(JSON.stringify(user.publicId));
                        // 업체 목록을 얻어온다
                        await custService.getCodeList(searchParams).then(data => {
                            custCodes.value = data;
                            // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                            searchParams.corpId = user.custSeq;
                            // 현재 선택된 업체에 속한 차량번호 목록을 다시 조회하여 Dropdown 목록에 표시한다
                            codeService.getTableCodeList({ sqlId:'car_code', compSeq:1, corpId: searchParams.corpId}).then(data=> {
                                cboCarNos.value = data;
                            });

                            if (user.userGbCd != null) {
                                // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                                if (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                    isCustUser.value = true;
                                    let ctrPublicIdList = [];

                                    publicCodes.value.forEach(element => {
                                        if (user.ctrPublicIds != null && user.ctrPublicIds.includes(element.code)) {
                                            ctrPublicIdList.push({
                                                code: element.code,
                                                codeNm: element.codeNm
                                            });
                                        }
                                    });

                                    //alert("ctrPublicIdList.length = "+ ctrPublicIdList.length);
                                    if (ctrPublicIdList.length > 0) {
                                        publicCodes.value = ctrPublicIdList;
                                        disabledCtrPublicId.value = false;
                                    } else {
                                        //publicCodes.value = {code:user.publicId, codeNm:user.publicNm};
                                        searchParams.ctrPublicId = user.publicId;
                                        disabledCtrPublicId.value = true;
                                    }
                                }
                                // 시군구담당자인 경우
                                if (user.userGbCd == 'ct_mngr') {
                                    searchParams.ctrPublicId = user.publicId; // 업체소재지
                                }
                            }
                        });
                }
            }
            
        })

        const maxDateValue = (row) => {
            return new Date(row.strYmd);
        }
        const endYmdDateValue = (row) => {
            return new Date(row.getYmd);
        }
        const getYmdDateValue = (row) => {
            return new Date(row.endYmd);
        }

        const isCustUser = ref(false);
		const codeService = new CodeService();
        const custService = new CustService();
        const ma301030Service = new MA301030Service();
        const searchParams = reactive({ctrPublicId:null,corpId:null,areaTag:null,runTag:null,carId:null,fromDate: null, toDate: null});
        const dataList = ref([]);
        const dataList2 = ref([]);
        const publicCodes = ref([]);
        const custCodes = ref([]);
        const useOilTagCodes = ref([]);
        const cboAreaTags = ref([]);
        const cboRunTags = ref([]);
        const cboCarNos = ref([]);
        const cboOilTags = ref([]);
        const toast = useToast();
        const loading = ref(false);
        const confirm = useConfirm();
        const editingRows = ref([]);
        const selectedItems = ref([]);

        // 관할행정 선택여부
        const disabledCtrPublicId = ref(false);

        // 엑셀 업로드 데이터
        const excelDataList = ref([]);
        // 엑셀 업로드 여부
        const isExcelUpload = ref(false);
        // 엑셀데이터 저장가능 여부
        const isExcelSave = ref(false);

        // 전체저장 활성화
        const isExcel = ref(false);

        // 사용 여부
        const yns = ref([
            {codeNm: '사용', code: 'Y'},
            {codeNm: '미사용', code: 'N'}
        ]);

        // 차량 종류
        const carTag = ref([
            {codeNm: '중형', code: '1'},
            {codeNm: '대형', code: '2'}
        ]);
        
        // 신규 / 수정 컬럼 체크
        const dataListOrigin = ref([]);
        const updateItemsIndex = ref([]);
        const init = () => {
            dataList.value = [];
            dataListOrigin.value = [];
            selectedItems.value = [];
            updateItemsIndex.value = [];
        }

        /**깊은 복사
         * @param {ArrayObject} arrayObject
         * ex) [{...}, {...}, ...]
         */
        const deepCopy = (arrayObject) => {
            return JSON.parse(JSON.stringify(arrayObject));
        }

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 
        
        // 엑셀 다운로드 관련
        const ma301030ExcelTempService = new MA301030ExcelTempService();
        const exceldataTemp = ref([]); // 엑셀에 있는 데이터를 저장하기 위한 테이블
        const errorMsgvisible = ref(true); //엑셀업로드시 커럼을 보여준다.

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "NEW": {
                        // 검색조건에 관할행정, 업체명이 있는 지 확인한다
                        if(!JsUtils.checkUndefineColumns(searchParams, ["ctrPublicId","corpId"])){
                            toast.add({severity:'warn', summary:'필수입력 확인', detail:'관할행정, 업체명은 필수입력 하셔야 합니다.', life:2000});
                            return true;
                        }

                        // 현재 목록의 첫번째 row에 신규 행을 추가한다
                        let _ = require('lodash');
                        let _corpNm = _.find(custCodes.value, {'code': searchParams.corpId}).codeNm; 
                        let _getYmd = JsUtils.getDateString(new Date());
                        let _strYmd = JsUtils.getDateString(new Date());
                        var corpCode = custCodes.value.find(e => e.code == searchParams.corpId );

                        let _orgYy = ref(JsUtils.getDateString(new Date()));  // 최초등록일자 현재일 날짜 체크
                        //let _endYmdMinDay = ref(new Date());       // 페기일자 날짜 체크

                        dataList.value.unshift({compSeq:searchParams.compSeq, publicId:corpCode.publicId, corpId:searchParams.corpId, ctrPublicId:searchParams.ctrPublicId,
                                                calcYm:searchParams.calcYm, useYn:'Y',
                                                orgYy:_orgYy, getYmd:_getYmd, strYmd:_strYmd, rowNo:'신규',
                                                getAmt:0,govAmt:0,
                                                calcCnt:searchParams.calcCnt,corpNm:_corpNm,carTag:1});
                    
                        // 목록의 첫번째 row를 편집 상태로 변경한다
                        editingRows.value = [...editingRows.value, dataList.value[0]];                    
                        break;  
                    }
                case "SEARCH":
                        searchMA301030();
                    break;
                case "SAVE":
                        if(!isExcelUpload.value) {
                            // 데이터그리드에서 등록/수정 시
                            saveList();
                        }
                        else {
                            // 엑셀 저장 시
                            saveExcel();
                        }
                        break;
                case "DELETE":
                        confirmDeleteList();
                    break; 
                default:
            }
        }

        const searchMA301030 = () => {
            searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);

            // 검색조건에 관할행정, 업체명이 있는 지 확인한다
            // if(!JsUtils.checkUndefineColumns(searchParams, ["corpId"])){
            //     toast.add({severity:'warn', summary:'필수입력 확인', detail:'업체명은 필수입력 하셔야 합니다.', life:2000});
            //     return true;
            // }

            isExcelUpload.value = false;
            loading.value = true;
            init();
            ma301030Service.getList(searchParams).then(data => {
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});
                dataList.value = data;
                dataListOrigin.value = deepCopy(data);
            }).finally(() => {
                loading.value = false;
                errorMsgvisible.value = true;
            });
        };

        const saveList = () => {
            confirm.require({
                message:'선택된 항목(들)을 저장하시겠습니까?',
                header: '저장',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    let _isError = false;
                    selectedItems.value.some(row => {
                        let errMsg = JsUtils.checkUndefineColumns2(row, ["publicId","corpNm","carNo","areaTag","runTag","orgYy","getYmd","useOilTag"]);
                        if(errMsg != null){
                            toast.add({severity:'warn', summary:'필수입력 확인', detail: '*는 필수입력 항목입니다', life:2000});
                            _isError = true;
                            return true;
                        }
                    });

                    // 에러가 있는 경우 종료한다 - 현재 저장 confirm 창을 닫는다
                    if(_isError) return false;
                    //alert('selectedItems.value.length = ' + selectedItems.value.length);
                    selectedItems.value.endYmd = JsUtils.convertDateToString(selectedItems.value.endYmd);

                    ma301030Service.updateList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                        searchMA301030();
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.request.data});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.message});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        const confirmDeleteList = () =>{
            confirm.require({
                message:'선택된 건(들)을 삭제하시겠습니까?',
                header: '삭제',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    deleteList();                    
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            })
        }

        const deleteList = () => {
            ma301030Service.deleteList(selectedItems.value)
                .then(() => {                    
                    dataList.value = [];
                    toast.add({severity:'success', summary: '삭제 성공', detail: '삭제 되었습니다', life: 3000});
                    btnAct('SEARCH');
                })
                .catch(error => {
                    toast.add({severity:'error', summary: '삭제 오류', detail: error.message, life: 3000});	
                });
        };

        // 셀 편집 후, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditComplete = (event) => {
            let {data, newValue, field } = event;
            if(data[field] === newValue) return;
            
            switch (field) {
                case "publicId": // 소재지
                case "ctrPublicId": // 관할행정구역
                case "corpNm": // 업체명
                case "carNo": // 차량번호
                case "areaTag": // 영역분류
                case "runTag": // 운행분류
                case "getAmt": // 
                case "govAmt": // 
                case "useOilTag": // 사용연료
                case "carModel": // 차량모델
                case "carMaker": // 차량제조사
                case "carTag": // 차량종류
                case "remarks": // 비고
                    data[field] = newValue;
                    break;
                case "useYn": {// 사용여부
                    data[field] = newValue;

                    // 사용여부 체크
                    if(newValue === 'Y'){ 
                        dataList.value.forEach(row => {
                            if(row.carNo == data.carNo){
                                row.useYnCnt++;
                            }
                        });
                        if(data.useYnCnt > 1){
                            data[field] = 'N';
                            toast.add({severity:'warn', summary:'사용여부 확인', detail: data.carNo+' 해당차량번호는 이미 사용중입니다.',});
                            dataList.value.forEach(row => {
                                if(row.carNo == data.carNo){
                                    row.useYnCnt--;
                                }
                            });
                        }
                    }
                    else {
                        dataList.value.forEach(row => {
                            if(row.carNo == data.carNo){
                                row.useYnCnt--;
                            }
                        });
                    }
                    break;
                }
                case "orgYy": // 최초등록일자
                case "getYmd": // 시작일자
                case "strYmd": // 개시일자
                case "endYmd": // 폐기일자
                    if(newValue == null || newValue == ' ') {
                        data[field] = "00000000";
                    }
                    else {
                        data[field] = JsUtils.convertDateToString(newValue);    // yyyymmdd 형식을 yyyy-mm-dd 형식으로 표시한다
                    }
                    break;
                default:
                    break;
            }
            
            // 수정 표시
            //dataList.value[data.rowNo-1].rowNo = '수정';

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용 예) corpId, lineId
            const _ = require('lodash');
            let _row = _.find(selectedItems.value, function(obj) {
                if (obj.rowNo === data.rowNo) {
                    return true;
                }
            });

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
                if(data.rowNo != null && data.rowNo !="신규") {
                    data.rowNo = '수정';
                }
            }

        };

        const rowClass = (data) => {
            return data.errorMsg != null ? 'row-error': null;
        };    

        const changePublicId = () => {
            if(isCustUser.value) {
                return;
            }
            custCodes.value = [];
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            custService.getCodeList(searchParams).then(data => {
                custCodes.value = data;
            });
            searchParams.corpId = null;
            searchParams.carId = null;
        }

        const changeCustSeq = () => {
            cboCarNos.value = [];
            // 현재 선택된 업체에 속한 차량번호 목록을 다시 조회하여 Dropdown 목록에 표시한다
            codeService.getTableCodeList({ sqlId:'car_code', compSeq:1, corpId: searchParams.corpId}).then(data=> {
                cboCarNos.value = data;
            });
            searchParams.carId = null;
        }

        // 액셀 다운로드
        const downloadExcel = () => {

            dataList2.value = [];
            dataList.value.forEach(row => {
            
            if(row.orgYy == null || (String(row.orgYy)).replace(/ /g,"") == "") {
                row.orgYy = "";
            }
            else {
                row.orgYy = JsUtils.convertDateString(String(row.orgYy));
            }
            if(row.getYmd == null || (String(row.getYmd)).replace(/ /g,"") == "") {
                row.getYmd = "";
            }
            else {
                row.getYmd = JsUtils.convertDateString(String(row.getYmd));
            }
            if(row.strYmd == null || (String(row.strYmd)).replace(/ /g,"") == "") {
                row.strYmd = "";
            }
            else {
                row.strYmd = JsUtils.convertDateString(String(row.strYmd));
            }
            if (row.endYmd == null || (String(row.endYmd)).replace(/ /g, "") == "") {
                row.endYmd = "";
            } else {
                row.endYmd = JsUtils.convertDateString(String(row.endYmd));
            }
                dataList2.value.push({'No': row.rowNo, '소재지': row.publicNm, '관할행정구역':row.ctrPublicNm, '업체ID':row.corpId, '업체명':row.corpNm, '차량ID':row.carId,  '차량번호':row.carNo, 
                '영역분류': row.areaTagNm, '운행분류':row.runTagNm, '최초등록일자':row.orgYy ,'취득일자':row.getYmd,'개시일자':row.strYmd, '폐기일자':row.endYmd , '취득금액':row.getAmt,'국가보조금':row.govAmt,
                '사용연료':row.useOilTagNm, '모델명':row.carModel, '제작사':row.carMaker, '차량종류':row.carTag != '1' ? '대형': '중형', '사용여부':row.useYn != 'Y' ? '미사용': '사용'});
            }); 

            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            JsUtils.downloadExcel(dataList2.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            //JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 날짜 변환
        const convertDateString = (data) => {
            return JsUtils.convertDateString(data);
        }

        // 엑셀 파일 선택시
        const selectExcel = (event) => {
            exceldataTemp.value = [];
            dataList.value = [];
            errorMsgvisible.value = false;
            
            if(!JsUtils.checkUndefineColumns(searchParams, ["ctrPublicId","corpId"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'엑셀 업로드시 관할행정과 업체명은 필수 입력입니다.', life:2000});
                return;
            }

            // 파일 확장자가(xlsx)가 아닌 경우
            if(event.files.length === 0) {
                toast.add({severity:'warn', summary:'파일 확장자 확인', detail:'엑셀 파일 확장자(xlsx)가 다릅니다 올바른 형식의 파일을 사용해주세요', life:5000});
                return;
            }

            const file = event.files[event.files.length - 1];
            let reader = new FileReader();
            reader.onload = () => {
                let data = reader.result; 
                let workbook = XLSX.read(data,  {type: 'binary', cellDates: true, dateNF: 'YYYY-MM-DD'});
                const sheetnames = Object.keys(workbook.Sheets);
                const sheetname = sheetnames[0]; // 첫번째 워크시트

                const worksheet = workbook.Sheets[sheetname];
                const options = { header: 1 };
                const sheetData = XLSX.utils.sheet_to_json(worksheet, options);
                const header = sheetData.shift();
                var header_Count = 0;
                //alert(JSON.stringify(header));
                header.forEach(element => {
                    if(element != null && element.replace(/ /g,"") != "") {
                        header_Count++;
                    }
                });
                if(header_Count != 17) {
                    toast.add({severity:'warn', summary:'엑셀 양식 오류', detail:'컬럼의 갯수가 다릅니다. 공지사항의 엑셀업로드 양식 사용법을 참조하십시오.'});
                    return;
                }

                workbook.Sheets[sheetname].A1.w = "publicNm";    //소재지
                workbook.Sheets[sheetname].B1.w = "ctrPublicNm"; //관할행정
                workbook.Sheets[sheetname].C1.w = "corpNm";        //업체명
                workbook.Sheets[sheetname].D1.w = "carNo";         //차량번호
                workbook.Sheets[sheetname].E1.w = "areaTagNm";     //영역분류
                workbook.Sheets[sheetname].F1.w = "runTagNm";      //운행분류
                workbook.Sheets[sheetname].G1.w = "orgYy";         //최초등록일자
                workbook.Sheets[sheetname].H1.w = "getYmd";        //취득일자
                workbook.Sheets[sheetname].I1.w = "strYmd";        //개시일자
                workbook.Sheets[sheetname].J1.w = "endYmd";        //폐기일자
                workbook.Sheets[sheetname].K1.w = "getAmt";        //취득금액
                workbook.Sheets[sheetname].L1.w = "govAmt";        //국가보조금
                workbook.Sheets[sheetname].M1.w = "useOilTagNm";   //사용연료
                workbook.Sheets[sheetname].N1.w = "carModel";      //모델명
                workbook.Sheets[sheetname].O1.w = "carMaker";      //제작사
                workbook.Sheets[sheetname].P1.w = "carTagNm";      //차량종류
                workbook.Sheets[sheetname].Q1.w = "remarks";       //비고

                exceldataTemp.value = XLSX.utils.sheet_to_json(workbook.Sheets[sheetname]);

                // 엑셀 파일 2000건이 넘는 경우
                if(exceldataTemp.value.length > 2000){
                    toast.add({severity:'warn', summary:'엑셀 파일 확인', detail:'엑셀파일이 너무 큽니다. 2000건 이하로 분할하여 업로드 해주세요.'});
                    return;
                }

                // 엑셀에서 날짜 컬럼이 object 또는 string 타입으로 넘어오기 때문에 string 타입은 그대로 사용하고, object 타입으로 넘어오는 경우 변환해서 사용해야 한다
                exceldataTemp.value.forEach(row => {
                    row.corpId = searchParams.corpId;
                    row.ctrPublicId = searchParams.ctrPublicId;
                  
                    // 개시일자
                    if(row.strYmd != null) {   // && String(row.gasYmd).trim() != ""
                        // 날짜(2019-12-31T15:00:00.000)인 경우 문자열 'YYYY-MM-DD' 형식으로 변환한다 ex) '2010-01-01'
                        if(typeof row.strYmd == 'object') {
                            var date1 = new Date(row.strYmd);
                            date1.setDate(date1.getDate() + 1); // 하루 +1
                            row.strYmd = JsUtils.convertDateToString(date1);
                        }
                        // 엑셀 일반타입(숫자) ex) 8자리
                        else if(typeof row.strYmd == 'number' && String(row.strYmd).length >= 8) {
                            row.strYmd = String(row.strYmd);
                            var _date = JsUtils.convertDateString(row.strYmd);
                            _date = new Date(_date);   
                            row.strYmd = JsUtils.convertDateToString(_date);
                        }
                        // 엑셀형 날짜데이터(숫자) 5자리
                        else if(typeof row.strYmd == 'number') {
                            row.strYmd = JsUtils.ExcelDateToJSDate2(row.strYmd);
                        }
                        else if(typeof row.strYmd == 'string') {
                            row.strYmd = row.strYmd.split(' ')[0];
                        }
                    }
                    // 폐기일자
                    if(row.endYmd != null) {   // && String(row.gasYmd).trim() != ""
                        // 날짜(2019-12-31T15:00:00.000)인 경우 문자열 'YYYY-MM-DD' 형식으로 변환한다 ex) '2010-01-01'
                        if(typeof row.endYmd == 'object') {
                            var date2 = new Date(row.endYmd);
                            date2.setDate(date1.getDate() + 1); // 하루 +1
                            row.endYmd = JsUtils.convertDateToString(date2);
                        }
                        // 엑셀 일반타입(숫자) ex) 8자리
                        else if(typeof row.endYmd == 'number' && String(row.endYmd).length >= 8) {
                            row.endYmd = String(row.endYmd);
                            var _date2 = JsUtils.convertDateString(row.endYmd);
                            _date2 = new Date(_date2);   
                            row.endYmd = JsUtils.convertDateToString(_date2);
                        }
                        // 엑셀형 날짜데이터(숫자) 5자리
                        else if(typeof row.endYmd == 'number') {
                            row.endYmd = JsUtils.ExcelDateToJSDate2(row.endYmd);
                        }
                        else if(typeof row.endYmd == 'string') {
                            row.endYmd = row.endYmd.split(' ')[0];
                        }
                    }
                    // 최초등록일자
                    if(row.orgYy != null) {   // && String(row.gasYmd).trim() != ""
                        // 날짜(2019-12-31T15:00:00.000)인 경우 문자열 'YYYY-MM-DD' 형식으로 변환한다 ex) '2010-01-01'
                        if(typeof row.orgYy == 'object') {
                            var date3 = new Date(row.orgYy);
                            date3.setDate(date3.getDate() + 1); // 하루 +1
                            row.orgYy = JsUtils.convertDateToString(date3);
                        }
                        // 엑셀 일반타입(숫자) ex) 8자리
                        else if(typeof row.orgYy == 'number' && String(row.orgYy).length >= 8) {
                            row.orgYy = String(row.orgYy);
                            var _date3 = JsUtils.convertDateString(row.orgYy);
                            _date3 = new Date(_date3);   
                            row.orgYy = JsUtils.convertDateToString(_date3);
                        }
                        // 엑셀형 날짜데이터(숫자) 5자리
                        else if(typeof row.orgYy == 'number') {
                            row.orgYy = JsUtils.ExcelDateToJSDate2(row.orgYy);
                        }
                        else if(typeof row.orgYy == 'string') {
                            row.orgYy = row.orgYy.split(' ')[0];
                        }
                    }
                    // 취득일자
                    if(row.getYmd != null) {   // && String(row.gasYmd).trim() != ""
                        // 날짜(2019-12-31T15:00:00.000)인 경우 문자열 'YYYY-MM-DD' 형식으로 변환한다 ex) '2010-01-01'
                        if(typeof row.getYmd == 'object') {
                            var date4 = new Date(row.getYmd);
                            date4.setDate(date4.getDate() + 1); // 하루 +1
                            row.getYmd = JsUtils.convertDateToString(date4);
                        }
                        // 엑셀 일반타입(숫자) ex) 8자리
                        else if(typeof row.getYmd == 'number' && String(row.getYmd).length >= 8) {
                            row.getYmd = String(row.getYmd);
                            var _date4 = JsUtils.convertDateString(row.getYmd);
                            _date4 = new Date(_date4);   
                            row.getYmd = JsUtils.convertDateToString(_date4);
                        }
                        // 엑셀형 날짜데이터(숫자) 5자리
                        else if(typeof row.getYmd == 'number') {
                            row.getYmd = JsUtils.ExcelDateToJSDate2(row.getYmd);
                        }
                        else if(typeof row.getYmd == 'string') {
                            row.getYmd = row.getYmd.split(' ')[0];
                        }
                    }


                });


                loading.value = true; 

                ma301030ExcelTempService.insertList(exceldataTemp.value).then(data => {
                    excelDataList.value = data;
                    loading.value = false;  
                    isExcelUpload.value = true;
                    isExcelSave.value = true;

                    // 에러메시지가 하나라도 있는 경우, 엑셀 업로드 데이터를 저장하지 못하게 한다 
                    excelDataList.value.some(row => {
                        if(row.errorMsg != null) {
                            isExcelSave.value = false;
                        }
                    });
                })
                .catch(error => {
                    loading.value = false;  
                    isExcelUpload.value = true;
                    isExcelSave.value = true;
                    toast.add({severity:'error', summary: '엑셀 데이터 로딩중 오류가 발생하였습니다.', detail: error.message, life: 3000});
                });

            };
            reader.readAsBinaryString(file);
        }

        /**
         * 엑셀 데이터들을 저장한다
         *  - 서버에 데이터를 보내서 저장하지 않고 임시 데이블에 있는 데이터로 insert ... select SQL로 한번에 등록한다
         */
        const saveExcel = () => {
            if(excelDataList.value[0].errorMsg != null){
                toast.add({severity:'warn', summary:'오류 메시지', detail:'오류 메시지를 확인해주세요.', life:3000});
                return;
            }
            
            loading.value = true;
            ma301030ExcelTempService.saveExcel().then(() => {
                loading.value = false;
                isExcelUpload.value = false;
                isExcelSave.value = false;
                toast.add({severity:'success', summary: '성공', detail: '등록 완료', life: 3000});
            })
            .catch(error => {
                if (error.response) {
                    toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 5000});
                } else if (error.request) {
                    toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 5000});
                } else {
                    toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 5000});
                }
            });
        } 

        //엑셀데이터 색상처리
        const excellrowcheckclass = (data) => {
            return data.errorMsg != null ? 'row-accessories-error' : null;
        }

        return { 
            dt, searchParams, dataList, publicCodes, useOilTagCodes, cboAreaTags, cboRunTags,cboCarNos,cboOilTags, isCustUser, loading, dataListOrigin, updateItemsIndex, init,
            yns, custCodes, formatToPrice, carTag, onCellEditComplete, selectedItems, maxDateValue, endYmdDateValue, getYmdDateValue, deepCopy, dataList2,
            isExcel, isExcelUpload, saveExcel, rowClass, excelDataList, isExcelSave, disabledCtrPublicId,
            btnAct, selectExcel, excellrowcheckclass, downloadExcel, exportCSV, changePublicId, changeCustSeq, convertDateString, errorMsgvisible
        }

    }
}
</script>

<style lang="scss" scoped>

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}
::v-deep(.row-error) {
	background-color: #F2D7D5 !important;
}
.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}

::v-deep(.row-accessories-error) {
    background: rgb(200, 200, 200) !important;
}
</style>
